import React from "react";
import { useSelector, useDispatch } from "react-redux";
import { StoreType } from "../../../../core/store/reducers";
import { EtfSummaryItem } from "../types";
import { loadEtfSummary } from "../thunks/getEtfSummaryThunk";

export const useDisplayEtfSummary = (
  symbol?: string
) => {
  const storeStatistics = useSelector<
    StoreType,
    EtfSummaryItem | undefined
  >((store) => store.data.reports.securityStatistics.displayEtfSummary);

  const displayedEtfSummary =
    storeStatistics && storeStatistics.symbol === symbol
      ? storeStatistics
      : undefined;

  const dispatch = useDispatch();

  React.useEffect(() => {
    if (symbol) {
      dispatch(loadEtfSummary( symbol));
    }
  }, [dispatch, symbol]);

  return displayedEtfSummary;
};